import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

function ContainerV2(props) {
    return (
        <div className="container-v2">
            {props.children}
        </div>
    );
}

ContainerV2.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ContainerV2;
